import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { ProductShop } from './views/ProductShop';
import { Background } from './components/Background';
import { store } from './redux';

const LayoutComponent = () => (
	<Provider store={store}>
		<Background />
		<ProductShop />
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.ProductShop)
	.build();

export default Layout;
